export const lenisRef = { current: null };

export function scrollToSection(selector) {
  if (lenisRef.current) {
    lenisRef.current.scrollTo(selector, { offset: -64, duration: 1.4 });
  } else {
    const el = document.querySelector(selector);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }
}
